export default function getHeaderText(usersData, user, userAssessment) {
  if (user.role === 'Student') {
    return user.fullName
  } else {
    if (userAssessment.groupType === 'School District') {
      const districtName = usersData.districts[userAssessment.groupId].name
      return districtName
    } else if (userAssessment.groupType === 'School') {
      const schoolName = usersData.schools[userAssessment.groupId].name
      return schoolName
    } else if (userAssessment.groupType === 'Teacher') {
      const teacherName = usersData.educators[userAssessment.groupId].fullName
      return teacherName
    } else if (userAssessment.groupType === 'Class') {
      const thisClass = usersData.classes[userAssessment.groupId]
      const teacher = usersData.educators[thisClass.teacher]
      return `${teacher.lastName}: ${thisClass.name}`
    }
  }
  return ''
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getHeaderText.js